import { ResetPasswordForm } from "@/components/auth/ResetPasswordForm";

/**
 * VIB-634: dedikert side for passordreset. AuthContext redirecter hit
 * automatisk når Supabase sender PASSWORD_RECOVERY-eventet (etter klikk
 * på lenken i reset-mail).
 */
export default function ResetPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <ResetPasswordForm />
    </div>
  );
}
